export default __webpack_public_path__ + "static/media/drag-drop.14fa16a6.svg";